module.exports = __webpack_public_path__ + "static/img/logo.aab7525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sy/logo.png
// module id = 8o9f
// module chunks = 1